module.exports = __webpack_public_path__ + "media/images/case-studies/South_East_Food_Hub-7a0a6d5abfcd65e90f94fb8b90e3cfbd.png";